import { Component, Input, OnInit, inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { MatchService } from '../../_core/services/match.service';
import { ToastService } from '../../_core/services/toast.service';
import { Match } from '../../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-follow-match',
    templateUrl: './follow-match.component.html',
    styleUrls: ['./follow-match.component.scss'],
})
export class FollowMatchComponent implements OnInit {
    private authService = inject(AuthService);
    private matchService = inject(MatchService);
    private toast = inject(ToastService);

    @Input() match: Match;

    canUnfollow: boolean;
    isLoadingFollow: boolean;

    ngOnInit() {
        if (this.match.dist.viewers.includes(this.authService.authUserSignal()?._id)) {
            this.canUnfollow = true;
        }
    }

    unfollow() {
        this.matchService.unfollow(this.match._id).subscribe(
            async responseSuccess => {
                this.canUnfollow = false;
                this.toast.presentToast('Match is unfollowed successfully.'),
                    this.matchService.publishUnfollow(this.match._id);
            },
            responseError => {
                //console.log(responseError)
            }
        );
    }

    follow() {
        this.isLoadingFollow = true;
        this.matchService.follow(this.match._id)
            .pipe(finalize(() => this.isLoadingFollow = false))
            .subscribe(
                async res => {
                    this.toast.presentToast('You are following a new match');
                    this.canUnfollow = true;
                    this.matchService.publishFollow(this.match);
                },
                err => {
                    //console.log(err)
                }
            );
    }

}
